import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const FREE_TIER = {
  tier: 'free',
  songLimit: 20,
  setlistLimit: 1,
  canMergePdf: false,
  canInviteMembers: false,
  overLimitSince: null,
  overLimitReasons: [],
};

function deriveFromTier(tier) {
  if (tier === 'free') return FREE_TIER;
  return {
    tier,
    songLimit: Infinity,
    setlistLimit: Infinity,
    canMergePdf: true,
    canInviteMembers: tier === 'band',
  };
}

export function useTier(tenantContext) {
  const bandId = tenantContext?.bandId ?? null;
  const [derived, setDerived] = useState(FREE_TIER);

  useEffect(() => {
    if (!bandId) {
      setDerived(FREE_TIER);
      return;
    }

    const unsub = onSnapshot(doc(db, 'bands', bandId), (snap) => {
      const data = snap.exists() ? snap.data() : {};
      const tier = data.tier ?? 'free';
      const overLimitSince = data.overLimitSince?.toDate?.() ?? null;
      const overLimitReasons = data.overLimitReasons ?? [];
      setDerived({ ...deriveFromTier(tier), overLimitSince, overLimitReasons });
    });

    return unsub;
  }, [bandId]);

  return derived;
}
